









import { Component, Mixins, Prop } from "vue-property-decorator";
import { Patient } from "../../domain/patient";
import { PatientFeatureAccessibleMixin } from "../patient/mixins";
import { SimplePatientViewer } from "../patient/viewers";
import { default as HeaderPane } from "./HeaderPane.vue";

@Component({
  components: {
    HeaderPane,
    SimplePatientViewer,
  }
})
export default class PatientSpecifiedHeaderPane extends Mixins(PatientFeatureAccessibleMixin) {
  @Prop()
  patient: Patient;

  @Prop({ default: true })
  shouldShowPatientInformation: boolean;
}
